var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vis-loading',{staticClass:"ba-h-screen ba-justify-center",attrs:{"size":"lg"}},[_vm._v("Выполняется проверка профиля пользователя…")])}
var staticRenderFns = []

export { render, staticRenderFns }